import {Box} from '@mui/material';

const RCMKPIComponent = ({data, chartData, ...props}: any) => {
  const renderKPICard = ({header, content, color}: any) => {
    return (
      <div
        style={{
          border: '2px solid black',
          borderRadius: '8px', // Rounded corners
          boxShadow: '4px 6px 12px rgba(0, 0, 0, 0.2)', // Smooth shadow
          //   padding: '16px',
          backgroundColor: color ?? '#fff',
          minWidth: '10vw'
        }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            paddingLeft: '16px',
            paddingRight: '16px',
            marginBottom: '12px',
            fontWeight: 'bold',
            borderBottom: '2px solid black'
          }}>
          {header}
        </div>

        <div
          style={{
            padding: '15px',
            display: 'flex',
            justifyContent: 'center',
            fontSize: 'larger'
          }}>
          {content}
        </div>
      </div>
    );
  };

  return (
    <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
      {chartData?.rcm_kpi_data?.map((item: any) => renderKPICard(item))}
    </Box>
  );
};

export default RCMKPIComponent;
